import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UmssIconButtonComponent } from '../icon-button/icon-button.component';

@Component({
  selector: 'umss-mobile-header',
  standalone: true,
  imports: [CommonModule, UmssIconButtonComponent],
  templateUrl: './mobile-header.component.html',
  styleUrls: ['./mobile-header.component.scss']
})
export class UmssMobileHeaderComponent {
  @Input() profile: 'Facility' | 'Contractor' | 'Business Admin' | 'Corporate' =
    'Facility';

  @Input() showNotifications = true;
  @Input() showSettings = false;

  @Output() menuClick = new EventEmitter<void>();
  @Output() notificationClick = new EventEmitter<void>();
  @Output() settingsClick = new EventEmitter<void>();

  onMenuClick(): void {
    this.menuClick.emit();
  }

  onNotificationClick(): void {
    this.notificationClick.emit();
  }

  onSettingsClick(): void {
    this.settingsClick.emit();
  }
}
